import Teaser from 'umg-ember-backend/components/record-explorer/for/teaser';

<template><Teaser @records={{@model}} @recordType='teaser' /></template>
